// Force landing starts at top - fix auto-scroll to #purchase on Shopify
if (history.scrollRestoration) history.scrollRestoration = 'manual';
if (location.hash) history.replaceState(null, '', location.pathname + location.search);
window.addEventListener('DOMContentLoaded', () => window.scrollTo(0, 0));
window.addEventListener('load', () => setTimeout(() => window.scrollTo({top: 0, left: 0, behavior: 'instant'}), 10));

// Mobile nav
const menuBtn = document.getElementById("senna-menu-btn");
const nav = document.getElementById("senna-main-nav");
if (menuBtn && nav) {
  menuBtn.addEventListener("click", () => {
    const open = nav.classList.toggle("open");
    menuBtn.setAttribute("aria-expanded", String(open));
  });
  nav.querySelectorAll("a").forEach(link => link.addEventListener("click", () => nav.classList.remove("open")));
}

// Gallery (per-variant)
document.querySelectorAll(".senna-root .gallery").forEach(gallery => {
  const main = gallery.querySelector(".senna-gallery-main");
  const count = gallery.querySelector(".count");
  const buttons = gallery.querySelectorAll(".thumbs button");
  const sync = () => {
    if (!count || !buttons.length) return;
    const idx = Array.from(buttons).findIndex(b => b.classList.contains("active"));
    count.textContent = `0${idx + 1} / 0${buttons.length}`;
  };
  sync();
  buttons.forEach(button => button.addEventListener("click", () => {
    buttons.forEach(b => b.classList.remove("active"));
    button.classList.add("active");
    if (main) main.src = button.dataset.image;
    sync();
  }));
});

// Variant picker (buttons mirrored in every panel; keep all in sync)
const selectVariant = id => {
  document.querySelectorAll(".senna-root .variant-btn").forEach(b => {
    const active = b.dataset.variant === id;
    b.classList.toggle("active", active);
    b.setAttribute("aria-pressed", String(active));
  });
  document.querySelectorAll(".senna-root .senna-variant").forEach(panel => {
    panel.classList.toggle("active", panel.id === id);
  });
};
document.querySelectorAll(".senna-root .variant-btn").forEach(btn => {
  btn.addEventListener("click", () => selectVariant(btn.dataset.variant));
});

// Scroll reveal
const observer = new IntersectionObserver(entries => entries.forEach(entry => {
  if (entry.isIntersecting) entry.target.classList.add("is-visible");
}), { threshold: 0.14 });
document.querySelectorAll(".senna-root [data-reveal]").forEach(el => observer.observe(el));

// Sticky bar on scroll past hero
const stickyBar = document.getElementById("senna-sticky-bar");
const hero = document.getElementById("legacy");
if (stickyBar && hero) {
  const stickyObserver = new IntersectionObserver(entries => {
    entries.forEach(entry => {
      if (!entry.isIntersecting) {
        stickyBar.style.display = "flex";
        requestAnimationFrame(() => stickyBar.classList.add("is-visible"));
      } else {
        stickyBar.classList.remove("is-visible");
        stickyBar.style.display = "none";
      }
    });
  }, { threshold: 0 });
  stickyObserver.observe(hero);
}

// WhatsApp per-ad-source greeting (distinct sentences so merchant can tell traffic origin)
(function () {
  const source = new URLSearchParams(location.search).get("utm_source");
  const messages = {
    google: "Halo PGJ Watches, saya sedang mencari TAG Heuer Formula 1 x Senna CAZ101AF.BA0637. Apakah stoknya ready sekarang?",
    meta: "Halo PGJ Watches! Saya baru lihat iklan TAG Heuer Formula 1 x Senna dan langsung tertarik. Boleh minta info ketersediaan dan harganya?"
  };
  const text = messages[source];
  if (!text) return;
  const encoded = encodeURIComponent(text);
  document.querySelectorAll(".senna-root a[href^='https://wa.me/']").forEach(a => {
    const base = a.href.split("?")[0];
    a.href = base + "?text=" + encoded;
  });
})();

// Lightbox — generic: one per data-lightbox group (showroom, senna-gallery)
document.addEventListener("DOMContentLoaded", function () {
  const root = document.querySelector(".senna-root");
  if (!root) return;

  const groups = {};
  root.querySelectorAll("[data-lightbox]").forEach(el => {
    (groups[el.dataset.lightbox] = groups[el.dataset.lightbox] || []).push(el);
  });

  const groupNames = Object.keys(groups);
  if (!groupNames.length) return;

  // Shared lightbox DOM (one instance; group drives its content)
  const box = document.createElement("div");
  box.className = "lightbox";
  box.setAttribute("role", "dialog");
  box.setAttribute("aria-modal", "true");
  box.innerHTML =
    '<button class="lightbox-close" type="button" aria-label="Close">&times;</button>' +
    '<button class="lightbox-prev" type="button" aria-label="Previous">&#8249;</button>' +
    '<button class="lightbox-next" type="button" aria-label="Next">&#8250;</button>' +
    '<img src="" alt="">' +
    '<div class="lightbox-counter"></div>';
  root.appendChild(box);

  const img = box.querySelector("img");
  const counter = box.querySelector(".lightbox-counter");
  let activeGroup = [];
  let index = 0;

  const show = i => {
    index = (i + activeGroup.length) % activeGroup.length;
    img.src = activeGroup[index].src;
    img.alt = activeGroup[index].alt;
    counter.textContent = String(index + 1).padStart(2, "0") + " / " + String(activeGroup.length).padStart(2, "0");
  };
  const open = (group, i) => {
    activeGroup = group;
    show(i);
    box.classList.add("open");
    document.body.style.overflow = "hidden";
  };
  const close = () => {
    box.classList.remove("open");
    document.body.style.overflow = "";
  };

  // Event delegation: survive late-rendered / lazy images
  root.addEventListener("click", e => {
    const item = e.target.closest("[data-lightbox]");
    if (!item) return;
    const group = groups[item.dataset.lightbox];
    const i = Array.from(group).indexOf(item);
    if (i !== -1) open(group, i);
  });

  box.querySelector(".lightbox-close").addEventListener("click", close);
  box.querySelector(".lightbox-prev").addEventListener("click", () => show(index - 1));
  box.querySelector(".lightbox-next").addEventListener("click", () => show(index + 1));
  box.addEventListener("click", e => { if (e.target === box) close(); });
  document.addEventListener("keydown", e => {
    if (!box.classList.contains("open")) return;
    if (e.key === "Escape") close();
    if (e.key === "ArrowLeft") show(index - 1);
    if (e.key === "ArrowRight") show(index + 1);
  });
});

// Senna gallery carousel — arrows + autoplay (left to right, wraps)
document.addEventListener("DOMContentLoaded", function () {
  const wrap = document.querySelector(".senna-root .senna-gallery-wrap");
  if (!wrap) return;
  const track = wrap.querySelector(".senna-gallery-grid");
  const row = wrap.parentElement;
  const prev = row.querySelector(".senna-gallery-nav.prev");
  const next = row.querySelector(".senna-gallery-nav.next");
  if (!track || !prev || !next) return;

  const card = () => (track.querySelector(".senna-gallery-item") || {}).offsetWidth || 240;
  const scrollBy = dir => {
    track.scrollBy({ left: dir * (card() + 12), behavior: "smooth" });
  };
  const atEnd = () => track.scrollLeft + track.clientWidth >= track.scrollWidth - 4;
  const atStart = () => track.scrollLeft <= 4;
  const wrapTo = () => {
    if (atEnd()) track.scrollTo({ left: 0, behavior: "smooth" });
    else if (atStart()) track.scrollTo({ left: track.scrollWidth, behavior: "smooth" });
  };

  prev.addEventListener("click", () => {
    if (atStart()) wrapTo();
    else scrollBy(-1);
    resetTimer();
  });
  next.addEventListener("click", () => {
    if (atEnd()) wrapTo();
    else scrollBy(1);
    resetTimer();
  });

  // Autoplay: pause on hover / touch / focus, resume after
  let timer = null;
  const startTimer = () => {
    if (timer) return;
    timer = setInterval(() => {
      if (atEnd()) track.scrollTo({ left: 0, behavior: "smooth" });
      else scrollBy(1);
    }, 3500);
  };
  const stopTimer = () => { if (timer) { clearInterval(timer); timer = null; } };
  const resetTimer = () => { stopTimer(); startTimer(); };

  ["mouseenter", "touchstart", "focusin"].forEach(ev => wrap.addEventListener(ev, stopTimer, { passive: true }));
  ["mouseleave", "touchend", "focusout"].forEach(ev => wrap.addEventListener(ev, startTimer, { passive: true }));

  startTimer();
});
